<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>
      Unknown Device Detected
    </template>
    <template v-slot:body>
      <p>
        We noticed you are logging in from an unknown device. An email has been sent to your address to verify your
        login attempt. Please check your email to proceed with logging in.
      </p>
      <p>
        You will not be able to login until this verification step is passed. Please
        <a href="#" @click.prevent="openChat">contact our team</a>
        if you have any
        questions.
      </p>
    </template>
    <template v-slot:actions>
      <gg-btn primary @click="close">
        Close
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { openChat } from '@/helpers/helpers'

export default {
  name: 'Email2FA',
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      openChat
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
